import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Registry } from '@/registry.service';
import { LoggerService } from '@services/logger.service';
import { BiggerDiscountService } from '@services/bigger-discount.service';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { UserService } from '@services/admin/user.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { DynamicFormPopUpInterface } from '@components/dynamic-form/dynamic-form-pop-up-interface';
import { MsCopyRowModel } from '@/models/tables/ms-copy-row.model';
import { MSCopyRowFormSetting } from '@/form-settings/ms-discount/mscopy-row-form-setting';

@Component({
  selector: 'app-ms-copy-row-form',
  templateUrl: '../../../../../components/dynamic-form/dynamic-form.component.html',
  styleUrls: ['../../../../../components/dynamic-form/dynamic-form.component.scss'],
})
export class MsCopyRowFormComponent
  extends DynamicFormComponent
  implements OnInit, OnChanges, DynamicFormPopUpInterface
{
  @Input() data: MsCopyRowModel;
  @Input() modalTrigger$ = new Subject<any>();

  constructor(
    protected userService: UserService,
    protected toastr: ToastrService,
    protected biggerDiscountService: BiggerDiscountService,
  ) {
    super(toastr, userService);

    this.submitButtonVisible = true;
    this.primaryButton = 'Copia';
    this.secondaryBottomButton = 'Chiudi';
  }

  public onSubmit() {
    let rawValue = this.form.getRawValue();
    const copyModel = {
      yearFrom: rawValue.yearMonthFrom.year(),
      monthFrom: rawValue.yearMonthFrom.month() + 1,
      monthTo: rawValue.yearMonthTo.month() + 1,
      yearTo: rawValue.yearMonthTo.year(),
      marca: this.data.marca,
      codiceMs: this.data.codiceMs,
    } as MsCopyRowModel;

    this.biggerDiscountService.copyMsRow(copyModel).subscribe({
      next: () => {
        this.toastr.success('Maggiore sconto copiato correttamente');
        setTimeout(() => this.modalTrigger$.next(1));
      },
      error: (error) => {
        LoggerService.error('copyMsRow failed!');
        LoggerService.error(error);
        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
      complete: () => {
        LoggerService.log('Request done');
        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
    });
  }

  ngOnInit(): void {
    this.setupMeta();
    if (this.data) {
      this.form.patchValue({
        yearMonthFrom: new Date(this.data.yearFrom, this.data.monthFrom - 1),
        codiceMs: this.data.codiceMs,
      });
    }
  }

  bottomButtonAction() {
    this.modalTrigger$.next(1);
  }

  setupMeta(): void {
    this.meta = MSCopyRowFormSetting.getMeta();
  }
}
